import React from 'react';

import { GetFiscalPrinterLocationDto } from '../../../common/spdCore/autogenerated/spdApiClient/models/GetFiscalPrinterLocationDto';
import { Grid } from '../../../common/components/Grid/Grid';
import {
  GridCountFunction,
  GridGetterFunction,
} from '../../../common/components/Grid/GridDataTypes';

interface FiscalPrinterLocationSearchProps {
  getData: GridGetterFunction;
  getCount: GridCountFunction;
  refresh?: boolean;
  onRowClick: (key: string) => Promise<void> | void | undefined;
}

export const fiscalPrinterLocationForGrid = (
  location: GetFiscalPrinterLocationDto,
) => {
  return {
    key: location.id,
    values: {
      'fiscalPrinterLocation.printerUid': location.printerUid,
      'healthcareFacility.displayName':
        location.healthcareFacility?.displayName,
    },
  };
};

export const FiscalPrinterLocationSearch: React.FC<
  FiscalPrinterLocationSearchProps
> = props => {
  const columns = [
    { header: 'UID drukarki', property: 'fiscalPrinterLocation.printerUid' },
    { header: 'Placówka', property: 'healthcareFacility.displayName' },
  ];

  return (
    <Grid
      getData={props.getData}
      getDataCount={props.getCount}
      columns={columns}
      showFilter={true}
      initialOrderColumn="fiscalPrinterLocation.printerUid"
      availablePageSizes={[10, 20, 50]}
      emptyGridMessage="Brak drukarek w systemie"
      enableMultiSelect={false}
      refresh={props.refresh}
      onRowClick={props.onRowClick}
    />
  );
};
